<template>
  <form
    class="flex w-full grow flex-col"
    @submit="onSubmit"
  >
    <div class="mb-6 space-y-6">
      <div class="flex w-full items-center justify-center">
        <div
          class="relative flex size-12 items-center justify-center rounded-full bg-primary text-white"
          :style="{
            backgroundColor:
              cashierPreviewColor ?? undefined,
          }"
        >
          {{ cashierPreviewShortString }}
        </div>
      </div>
      <TextInputFormField name="username" label="Name" />

      <BaseColorInput name="color" label="Display Color" />

      <FormInputPin name="pin" label="Pin" />
    </div>

    <ActionButtonPrimary
      type="submit"
      class="mt-auto w-full"
    >
      Save Cashier
    </ActionButtonPrimary>
  </form>
</template>

<script setup lang="ts">
import {
  useCashierForm,
  type CashierFormOutput,
} from "@/forms/cashierForm"
import { retrieveCashier } from "@/services/cashiers/retrieveCashier"

const props = defineProps<{
  cashierId?: string
}>()

const emit = defineEmits<{
  (event: "submit", params: CashierFormOutput): void
}>()

const { startLoading, stopLoading } =
  usePageBlockingLoading()

const { handleSubmit, values, setValues } = useCashierForm()

const onSubmit = handleSubmit(async (params) => {
  emit("submit", params)
})

onMounted(async () => {
  if (!props.cashierId) return

  startLoading()
  try {
    const cashier = await retrieveCashier(props.cashierId)

    setValues(cashier)
  } finally {
    stopLoading()
  }
})

const cashierPreviewColor = computed(() => values.color)

const cashierPreviewShortString = computed(() =>
  buildShortString(values.username ?? "")
)
</script>
